import React, { Component, useState, useEffect, useContext } from "react";
import { Form, Input, Button, Select } from "antd";
import CenterElement from "../common/layout/CenterElement";
import { FormCreateOption } from "antd/lib/form";
const FormItem = Form.Item;

function AddFilterForm(props: Props) {
  const { getFieldDecorator } = props.form;
  const [saving, setSavingStatus] = useState(false);
  useEffect(() => props.form.setFieldsValue({ scope: "Private" }), []);

  const handleSubmit = e => {
    e.preventDefault();
    setSavingStatus(true);
    props.form.setFieldsValue({ add_new_test_case: 0 });
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        props.saveFilter(values);
        setSavingStatus(false);
      } else {
        setSavingStatus(false);
      }
    });
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <FormItem label="Name" key="title">
          {getFieldDecorator(`title`, {
            rules: [
              {
                required: true,
                message: "This field is required"
              },
              {
                whitespace: true,
                message: "Title cannot be left blank"
              }
            ]
          })(<Input placeholder="Name for your saved filter" />)}
        </FormItem>

        <FormItem label="Who can see this filter?" key="suite">
          {getFieldDecorator("scope", {
            placeholder: "Select scope",
            rules: [
              {
                //required: true,
                message: "Scope cannot be left blank"
              }
            ]
          })(
            <Select>
              <Select.Option key={"private"} value={"Private"}>
                Only Me
              </Select.Option>
              {props.canManageSavedFilters ? (
                <Select.Option key={"public"} value={"Public"}>
                  Everyone
                </Select.Option>
              ) : null}
            </Select>
          )}
        </FormItem>
        <CenterElement>
          <Button type="primary" htmlType="submit" loading={saving}>
            Save
          </Button>{" "}
          &nbsp;
          <Button onClick={props.onDone} type="default" className="btn-gray">
            Cancel
          </Button>
        </CenterElement>
      </Form>
    </div>
  );
}
interface Props {
  saveFilter: (values: object) => Promise<void>;
  onDone: () => void;
  form: any;
  canManageSavedFilters: boolean;
}
const mapPropsToFields = { mapPropsToFields(props: Props) {} };
const FormOptions: FormCreateOption<Props> = mapPropsToFields;
const AddFilter = Form.create(FormOptions)(AddFilterForm);

export default AddFilter;
